<template>
  <span>
    <img
      src="/clientV2/static/gfx/calendar.svg"
      class="iconBtn transition"
      v-tippy="{ placement : 'top'}"
      id="toolBarCalendarIcon"
      @click="calendarToggle = true"
      :title="(options.title) ? options.title : 'בחר תאריך לתצוגה'"
    >

    <div
      class="datespan"
      @click="calendarToggle = true"
      v-if="periodLabel"
      style="margin-left: 15px; cursor: pointer;"
    >{{periodLabel}}</div>
    <ul
      class="excelList"
      v-if="calendarToggle === true && options.type === 'years'"
      v-menufocus:opt="{class: 'excelList', trigger: 'calendarToggle', el: 'toolBarCalendarIcon'}"
    >
      <li
        v-for="year in years"
        @click="emitEvent({method: 'selectYear', data: year}); calendarToggle = false; setPeriodLabel(year);"
        :class="{'activeYear': parseInt(year) === periodLabel}"
      >{{year}}</li>
    </ul>

    <div
      class="calendarContainer"
      v-if="calendarToggle === true && options.type === 'months'"
      v-menufocus:opt="{class: 'calendarContainer', trigger: 'calendarToggle', el: 'toolBarCalendarIcon'}"
    >
      <div class="calendarExtra" v-if="extraOptions">
        <div @click="selectPeriod(1,6)">הצג חציון א' (ינואר-יוני {{currentYear}})</div>
        <div @click="selectPeriod(7,12)">הצג חציון ב' (יולי-דצמבר {{currentYear}})</div>
        <div @click="selectPeriod(1,12)">הצג ינואר - דצמבר {{currentYear}}</div>
      </div>
      <div class="calendarHeader">
        <div class="arrow" @click="selectYear('--')"><</div>
        <div class="year">{{currentYear}}</div>
        <div class="arrow" @click="selectYear('++')">></div>
      </div>
      <div class="calendarHeader"></div>
      <div class="monthsContainer">
        <div
          v-for="(month, k) in months"
          @click="selectMonth(month.number, month.label)"
          @mouseover="paintMonths(month.number)"
          :class="{'monthSelected': periodArray.indexOf(month.number) > -1}"
        >{{month.label}}</div>
      </div>
      <div class="clearCalendar" @click="clearCalendar()">איפוס לוח שנה</div>
    </div>
  </span>
</template>

<script>
  export default {
    name: 'CalendarElement',
    props: ['options', 'extraOptions'],
    data() {
      return {
        periodLabel: null,
        currentYear: null,
        calendarToggle: false,
        years: [2017, 2018, 2019, 2020],
        periodArray: [],
        periodType: 'range',
        period: '1-12',
        months: [
          {"number": "1", "label": "ינואר"},
          {"number": "2", "label": "פברואר"},
          {"number": "3", "label": "מרץ"},
          {"number": "4", "label": "אפריל"},
          {"number": "5", "label": "מאי"},
          {"number": "6", "label": "יוני"},
          {"number": "7", "label": "יולי"},
          {"number": "8", "label": "אוגוסט"},
          {"number": "9", "label": "ספטמבר"},
          {"number": "10", "label": "אוקטובר"},
          {"number": "11", "label": "נובמבר"},
          {"number": "12", "label": "דצמבר"}]
      }
    },
    methods: {
      selectPeriod: function (start, end) {
        // this.period = period
        this.periodArray = []
        $('.period').removeClass('period')
        this.$emit('emit', {start: start, end: end, method: 'selectPeriod'})
      },
      paintMonths: function (month) {
        if (this.periodArray.length === 1) {
          $('.period').removeClass('period')
          let tempArray = [this.periodArray[0] - 1, month].sort((a, b) => {
            return a - b
          })
          $('.monthsContainer').find('div')
            .each(function (i) {
              if (i > tempArray[0] && i < tempArray[1]) {
                $(this).addClass('period')
              }
            })
        }
      },
      selectYear: function (type) {
        if (type === '++') {
          this.currentYear++
        } else {
          this.currentYear--
        }
        this.setPeriodLabel()
        this.$emit('emit', {year: this.currentYear, method: 'selectYear'})
      },
      selectMonth: function (month) {
      if(this.options.feature && this.options.feature == 'maintenance'){
        this.currentYear = new Date().getFullYear()
      }
        if (this.periodType === 'range') {
          if (this.periodArray.length === 2) {
            $('.period').removeClass('period')
            this.periodArray = []
          }
          if (this.periodArray.length < 2) {
            this.periodArray.push(month)
          }
          this.firstMonthSelected = true
          let _this = this
          if (this.periodArray.length === 2) {
            this.periodArray = this.periodArray.sort((a, b) => {
              return a - b
            })
            $('.monthsContainer').find('div')
              .each(function (i) {
                if (i > (_this.periodArray[0] - 1) && i < _this.periodArray[1]) {
                  $(this).addClass('period')
                }
              })
            this.period = this.periodArray.sort((a, b) => {
              return a - b
            })
          }
          this.emitEvent({start: this.periodArray[0], end: this.periodArray[1], method: 'getByDate'})
        } else {
          this.period = month
          this.calendarToggle = false
          this.emitEvent({month: month, year: this.currentYear, method: 'monthSelected'})
        }
        this.setPeriodLabel();
      },
      setPeriodLabel: function (year) {
        let tmp = this.period
        if (year) {
          this.currentYear = year;
        }
        if (tmp.includes('-')) {
          tmp = tmp.split('-').map(part => {
            return parseInt(part) - 1
          })

          if (tmp[0] != tmp[1]) {
            this.periodLabel = `${this.months[tmp[0]].label} - ${this.months[tmp[1]].label} ${this.currentYear}`
          } else {
            this.periodLabel = `${this.months[tmp[0]].label} ${this.currentYear}`
          }
        } else {
          this.periodLabel = `${this.months[tmp[0]].label} ${this.currentYear}`;
        }
        if(this.options.feature && this.options.feature == 'maintenance'){
         let tmp = this.period
         this.periodLabel = `${this.months[tmp[0]-1].label} - ${this.months[tmp[1]-1].label} ${this.currentYear}`
      }
      },
      clearCalendar() {
        this.period = '1-12'
        this.selectMonth(1)
        this.selectMonth(12)
      },
      emitEvent: function (data) {
        this.$emit('emit', data)
      }
    },
    created() {
      if (this.options.period) this.period = this.options.period;
      this.currentYear = this.options.periodLabel;
      this.periodLabel = (this.options.periodLabel) ? this.options.periodLabel : null;
      this.periodType = this.options.periodType || 'range';
      this.setPeriodLabel();
    }
};
</script>

<style scoped lang="less">
@import "../../assets/css/style.less";

.datespan {
  vertical-align: middle;
}

.activeYear {
  background: #eee;
  color: @blue-dark;
  &:hover {
    background: #eee;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/toolbar/CalendarElement.vue